import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { PrequalificationModel } from '../models/prequalification.model';
import { ApiRequestService } from '../shared/api-request.service';
import { ApiResponseModel } from '../models/api-response.model';

type ResponseEntity = ApiResponseModel<PrequalificationModel>;
type ResponseEntities = ApiResponseModel<PrequalificationModel[]>;

@Injectable({
  providedIn: 'root'
})
export class PrequalificationService {
  private readonly resourceUrl = 'prequalifications';

  constructor(private api: ApiRequestService) {}

  public resetShareLink(id: number): Observable<ApiResponseModel<string>> {
    return this.api.makeRequestObservable(
      'patch',
      'v1/' + this.resourceUrl + `/${id}/reset-hash`
    );
  }

  public remove(ids: number[]): any {
    return this.api.makeRequestObservable(
      'delete',
      `v1/prequalifications/${ids.join(',')}`
    );
  }

  public find(id: number, eager_load = false): Observable<ResponseEntity> {
    if (eager_load) {
      return this.api.makeRequestObservable(
        'get',
        `v1/prequalifications/${id}?eager_load=true`
      );
    }
    return this.api.makeRequestObservable('get', `v1/prequalifications/${id}`);
  }

  public get(template?: boolean): Observable<ResponseEntities> {
    return this.api.makeRequestObservable(
      'get',
      `v1/prequalifications`,
      {},
      { offset: 0, sort_by: 'name', order: 'asc', template: template }
    );
  }

  public create(prequal: PrequalificationModel): Observable<PrequalificationModel> {
    return this.api.makeRequestObservable('post', 'v1/prequalifications', prequal);
  }

  public update(prequal: PrequalificationModel): Observable<PrequalificationModel> {
    return this.api.makeRequestObservable(
      'put',
      `v1/prequalifications/${prequal.id}`,
      prequal
    );
  }

  public exportPdf(id: number): Promise<any> {
    return this.api.makeDownloadRequest(`v1/prequalifications/export/${id}`);
  }

  public toggleDefault(id: number) {
    return this.api.makeRequestObservable(
      'patch',
      `v1/prequalifications/${id}/toggle-default`
    );
  }

  public toggleNotifications(id: number) {
    return this.api.makeRequestObservable(
      'put',
      `v1/prequalifications/${id}/toggle-notifications`
    ).toPromise();
  }
}
